import React, { useState, useEffect, useRef } from "react";

import "../../css/Navbar.css";

import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.js";

import ic_line from "../../assets/icon/ic-line.png";
import ic_traffy from "../../assets/icon/ic-traffy.png";
import ic_fondue from "../../assets/icon/ic-fondue.png";
import ic_porpor from "../../assets/icon/ic-porpor.png";

/////////////   Redux  //////////////
import { saveLanguageWeb } from "../../store/LanguageSlice";
import { useSelector, useDispatch } from "react-redux";

export default function NavbarEN(props) {
  const globalData = useSelector((state) => ({ ...state }));
  const dispatch = useDispatch();

  const [openBurger, setOpenBurger] = useState(false);

  const changeLang = () => {
    dispatch(saveLanguageWeb(!globalData.language.toggle_language));
  };

  return (
    <div className="navbar-container">
      <div className="icon_group_left">
        <img
          className="Logo_Navbar"
          src={ic_porpor}
          onClick={(event) => {
            event.preventDefault();
            window.open("https://www.disaster.go.th/intro.php", "_blank");
          }}
        />
        <img
          className="Logo_Navbar"
          src={ic_fondue}
          onClick={(event) => {
            event.preventDefault();
            window.open("https://lin.ee/nwxfnHw", "_blank");
          }}
        />
        <img
          className="Logo_Navbar"
          src={ic_traffy}
          onClick={(event) => {
            event.preventDefault();
            window.open("https://www.traffy.in.th/", "_blank");
          }}
        />
      </div>

      {/* <div className="icon_group_right">
        <a
          className="container-btn-report-line-en"
          onClick={(event) => {
            event.preventDefault();
            window.open(
              "https://page.line.me/155zwaue?openQrModal=true",
              "_blank"
            );
          }}
        >
          <p className="txt-eng">Report issue via </p>
          <img className="Line_Icon" src={ic_line} />
        </a>

        <div>
          <label className="switch">
            <input
              type="checkbox"
              checked={globalData.language.toggle_language}
              onChange={changeLang}
            />
            <span className="slider round"></span>
            {globalData.language.toggle_language === false ? (
              <span className="language language-eng">ENG</span>
            ) : (
              <span className="language language-th">TH</span>
            )}
          </label>
        </div>
      </div> */}

      <div
        className={openBurger ? "icon_group_right active" : "icon_group_right"}
      >
        <a
          className="container-btn-report-line-en"
          onClick={(event) => {
            event.preventDefault();
            window.open("https://page.line.me/155zwaue?openQrModal=true", "_blank");
          }}
        >
          <p className="txt-eng">Report issue via </p>
          <img className="Line_Icon" src={ic_line} />
        </a>

        {/* <div> */}
        <label className="switch">
          <input
            type="checkbox"
            checked={globalData.language.toggle_language}
            onChange={changeLang}
          />
          <span className="slider round"></span>
          {globalData.language.toggle_language === false ? (
            <span className="language language-eng">ENG</span>
          ) : (
            <span className="language language-th">TH</span>
          )}
        </label>
        {/* </div> */}
      </div>
      <div className="menu-icons" onClick={() => setOpenBurger(!openBurger)}>
        <i className={openBurger ? "fas fa-times" : "fas fa-bars"}></i>
      </div>
    

    </div>
  );
}
